export const supportedLanguages = ['de', 'en'];

export default {

  getCurrentLang() {

    const url = window.location.href;
    if (url.includes('/de/')) {
      return 'de'
    } else {
      return 'en'
    }
  }

}
